/* ================================================================
   ALPHA HOME — comportamiento propio del home
   Archivo: assets/alpha-home.js

   Solo hace lo que el CSS no puede:
     1. Dibujar las guias del diagrama de componentes cuando entra.
     2. El selector de medida, que ademas reapunta el boton de compra
        a la variante elegida.

   Cero librerias, igual que alpha-motion.js. Todo degrada: si este
   archivo no corre, el diagrama se ve completo y el selector sigue
   siendo un enlace normal a la ficha de producto.
   ================================================================ */

(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- 1. Diagrama de componentes ----------------
     Solo decide CUANDO se dibuja. El COMO ya no pasa por aqui: las
     guias declaran pathLength="1" en el SVG, asi que el CSS las dibuja
     con dasharray 1 y dashoffset de 1 a 0 sin que nadie mida nada.
     Antes se median con getTotalLength() y la longitud viajaba en una
     variable CSS; cuando ese valor no llegaba a stroke-dashoffset, el
     respaldo dejaba el trazo desplazado y la guia se cortaba antes de
     tocar su punto. */

  function initDiagrama() {
    var bloques = document.querySelectorAll('.ah-comp');
    if (!bloques.length) return;

    Array.prototype.forEach.call(bloques, function (bloque) {
      // Sin IntersectionObserver o sin movimiento: se muestra ya.
      if (reduce || !('IntersectionObserver' in window)) {
        bloque.classList.add('is-drawn');
        return;
      }

      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          bloque.classList.add('is-drawn');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });

      io.observe(bloque);

      // Seguro: si el observer no dispara en 3 s y el bloque esta en
      // pantalla, se destapa igual. Nunca se queda contenido oculto.
      setTimeout(function () {
        if (bloque.classList.contains('is-drawn')) return;
        var r = bloque.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) bloque.classList.add('is-drawn');
      }, 3000);
    });
  }

  /* ---------------- 2. Selector de medida ----------------
     Los botones llevan data-largo, data-variante y data-imagen.
     Al pulsarlos cambian el estado, la foto y el destino del CTA. */

  function initMedidas() {
    var bloques = document.querySelectorAll('[data-ah-size]');
    if (!bloques.length) return;

    Array.prototype.forEach.call(bloques, function (bloque) {
      var opciones = bloque.querySelectorAll('.ah-size__opt');
      var cta = bloque.querySelector('[data-ah-size-cta]');
      var foto = bloque.querySelector('[data-ah-size-img]');
      var base = cta ? cta.getAttribute('href') : null;
      if (!opciones.length) return;

      function elegir(btn) {
        Array.prototype.forEach.call(opciones, function (o) {
          o.setAttribute('aria-pressed', String(o === btn));
        });

        var variante = btn.getAttribute('data-variante');
        if (cta && base && variante) {
          var limpio = base.split('?')[0];
          cta.setAttribute('href', limpio + '?variant=' + variante);
        }

        var img = btn.getAttribute('data-imagen');
        if (foto && img && foto.getAttribute('src') !== img) {
          foto.setAttribute('src', img);
          var srcset = btn.getAttribute('data-imagen-srcset');
          if (srcset) foto.setAttribute('srcset', srcset);
        }
      }

      Array.prototype.forEach.call(opciones, function (btn) {
        btn.addEventListener('click', function () { elegir(btn); });
      });
    });
  }

  /* ---------------- 3. Alto real del hero ----------------
     Todo lo que se dibuja encima de <main> (la barra de anuncio, y
     el header cuando no flota) le resta altura util al hero. Sin
     esto, 100svh empuja el pie del hero fuera del pliegue justo esa
     cantidad. Se mide una vez y en cada resize. */

  function medirChrome() {
    var main = document.querySelector('main');
    if (!main) return;
    var alto = Math.max(0, Math.round(main.getBoundingClientRect().top + window.pageYOffset));
    document.documentElement.style.setProperty('--ah-chrome', alto + 'px');
  }

  /* ---------------- 4. Lustre ----------------
     El barrido especular del hero. Corre UNA vez, cuando la foto ya
     esta decodificada: si se dispara antes, el usuario ve la banda
     cruzar un hueco vacio y el efecto se pierde. Nada aqui es
     necesario para leer la pagina; si falla, la foto se ve igual. */

  function initLustre() {
    var piezas = document.querySelectorAll('.ah-lustre');
    if (!piezas.length || reduce) return;

    Array.prototype.forEach.call(piezas, function (pieza) {
      var img = pieza.querySelector('img');

      function encender() {
        // Un frame de margen para que el navegador haya pintado la foto.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { pieza.classList.add('is-lit'); });
        });
      }

      function cuandoEsteLista() {
        if (!img) { encender(); return; }
        if (img.complete && img.naturalWidth > 0) { encender(); return; }
        img.addEventListener('load', encender, { once: true });
        // Si la foto no carga, no se enciende nada: mejor sin efecto
        // que una banda de luz sobre un hueco.
        img.addEventListener('error', function () {}, { once: true });
      }

      // Sobre el pliegue entra directo; mas abajo, al asomarse.
      var r = pieza.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { cuandoEsteLista(); return; }

      if (!('IntersectionObserver' in window)) { cuandoEsteLista(); return; }

      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          cuandoEsteLista();
        });
      }, { threshold: 0.25 });

      io.observe(pieza);
    });
  }

  /* ---------------- 5. Completar la fila de Escala ----------------
     alpha-motion.js reparte como maximo 6 revelados por seccion, y en
     Escala los <p> de los pies consumen turnos: antetitulo, titular,
     bajada, foto 1, pie 1, foto 2 — y el cupo se agota antes de llegar
     a la foto 3, que entonces aparece de golpe mientras las otras dos
     se descubren. Los tres planos son un conjunto comparativo: o entran
     los tres o no entra ninguno.

     Se completa aqui en vez de tocar alpha-motion.js, que es compartido
     con el resto del sitio. */

  function completarFila() {
    var huerfanos = document.querySelectorAll('.ah-macro__frame:not([data-alpha-reveal])');
    if (!huerfanos.length) return;

    var io = ('IntersectionObserver' in window) && !reduce
      ? new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
      : null;

    Array.prototype.forEach.call(huerfanos, function (el) {
      var i = 0, hermano = el.closest('.ah-macro__item');
      if (hermano && hermano.parentElement) {
        i = Array.prototype.indexOf.call(hermano.parentElement.children, hermano);
      }
      el.setAttribute('data-alpha-reveal', '');
      el.setAttribute('data-alpha-delay', String(Math.min(i, 5)));
      el.setAttribute('data-am-kind', 'media');

      if (!io) { el.classList.add('is-in'); return; }

      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('is-in'); });
        });
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------------- 6. Red de seguridad ----------------
     EL PROBLEMA. alpha-motion.css deja las imagenes recortadas a cero
     (clip-path: inset(0 0 100% 0)) hasta que un IntersectionObserver
     les pone .is-in. Es decir: la foto se descarga y no se ve. Si el
     observer no dispara —y se ha medido en produccion que no siempre
     dispara— las fotos del producto quedan invisibles para siempre en
     una tienda que esta vendiendo. Los seguros de alpha-motion.js solo
     rescatan lo que ya esta en pantalla y solo durante 20 segundos.

     LA SOLUCION. Un rescate que no depende de IntersectionObserver:
     escucha scroll y resize —eventos que si llegan siempre— y revela
     lo que ya entro en pantalla. No sustituye al observer, lo respalda:
     cuando el observer funciona, llega primero y esto no hace nada.
     Añadir .is-in dos veces es inocuo.

     Y un plazo final: a los 15 segundos se destapa TODO lo que siga
     oculto, haya pasado lo que haya pasado. Una animacion perdida es
     un detalle; una foto de producto invisible es una venta perdida.

     Se apaga solo en cuanto no queda nada oculto.                    */

  function redSeguridad() {
    var main = document.querySelector('main[data-template^="index"]');
    if (!main) return;

    var pendiente = false;

    function ocultos() {
      return main.querySelectorAll(
        '[data-alpha-reveal]:not(.is-in), .am-rule:not(.is-in)'
      );
    }

    // Un rato despues de revelar se fija el destino con .is-shown, que
    // en CSS anula clip-path, opacidad y transform sin transicion. Si la
    // animacion corrio, no cambia nada. Si el compositor estaba pausado
    // y la transicion nunca avanzo, la foto aparece igual.
    // 900 ms cubre barrido (340) + escalonado (150) + holgura.
    function asegurarDestino(el) {
      setTimeout(function () { el.classList.add('is-shown'); }, 900);
    }

    function revelar(todo) {
      var lista = ocultos();
      var vh = window.innerHeight || 800;

      Array.prototype.forEach.call(lista, function (el) {
        if (todo || el.getBoundingClientRect().top < vh * 1.05) {
          el.classList.add('is-in');
          asegurarDestino(el);
        }
      });

      // Lo que alpha-motion.js ya revelo por su cuenta tambien necesita
      // su destino asegurado.
      Array.prototype.forEach.call(
        main.querySelectorAll('[data-alpha-reveal].is-in:not(.is-shown), .am-rule.is-in:not(.is-shown)'),
        asegurarDestino
      );

      // El diagrama y el lustre viven fuera del contrato de reveal.
      Array.prototype.forEach.call(main.querySelectorAll('.ah-comp:not(.is-drawn)'), function (c) {
        var r = c.getBoundingClientRect();
        if (todo || (r.top < vh && r.bottom > 0)) {
          c.classList.add('is-drawn');
          // Las guias se dibujan con una transicion de stroke-dashoffset:
          // mismo riesgo, mismo seguro.
          Array.prototype.forEach.call(c.querySelectorAll('.ah-comp__lead'), asegurarDestino);
        }
      });

      if (!reduce) {
        Array.prototype.forEach.call(main.querySelectorAll('.ah-lustre:not(.is-lit)'), function (p) {
          var r = p.getBoundingClientRect();
          var img = p.querySelector('img');
          var lista_ = !img || (img.complete && img.naturalWidth > 0);
          if (lista_ && (todo || (r.top < vh && r.bottom > 0))) p.classList.add('is-lit');
        });
      }

      if (!ocultos().length) desconectar();
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        try { revelar(false); } catch (e) {}
      });
    }

    function desconectar() {
      window.removeEventListener('scroll', alScroll);
      window.removeEventListener('resize', alScroll);
      window.removeEventListener('pageshow', alScroll);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll);
    window.addEventListener('pageshow', alScroll);

    revelar(false);
    window.addEventListener('load', function () { try { revelar(false); } catch (e) {} });

    // Plazo final. Nada se queda oculto pasados 15 s.
    setTimeout(function () {
      try { revelar(true); } catch (e) {}
      desconectar();
    }, 15000);
  }

  ready(function () {
    try { medirChrome(); } catch (e) {}
    try { initDiagrama(); } catch (e) {}
    try { initMedidas(); } catch (e) {}
    try { initLustre(); } catch (e) {}
    // Despues de que alpha-motion.js haya repartido lo suyo.
    setTimeout(function () {
      try { completarFila(); } catch (e) {}
      try { redSeguridad(); } catch (e) {}
    }, 0);
  });

  window.addEventListener('load', function () { try { medirChrome(); } catch (e) {} });

  var reTimer;
  window.addEventListener('resize', function () {
    clearTimeout(reTimer);
    reTimer = setTimeout(function () { try { medirChrome(); } catch (e) {} }, 180);
  });
})();
